/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState } from 'react';
import styled from 'styled-components';
import { Loader, Modal } from '../../../../UiKit';
import { PickerImageViewer } from '../OrderPickerImages/PickerImageViewer';
import { EmptyState } from '../../../commons';
import { InvalidSearchImg } from '../../../../images/images';
import { useQueryCall } from '../../../../api/react-client';
import { lifelineEndPoints } from '../../../../api/end-points';
import { useSelector } from 'react-redux';

export function OrderRiderImages({ orderId }) {
  const [isVisible, setIsVisible] = useState(false);
  const isNewUI = useSelector((state) => state.ordersState?.isNewUI);

  if (!orderId) return null;

  return (
    <>
      <div
        className='tw-text-300 tw-font-medium tw-text-base-green tw-cursor-pointer'
        onClick={() => setIsVisible(true)}
      >
        {isNewUI ? 'Instructions Images' : 'View Rider Images'}
      </div>
      {isVisible && (
        <OrderRiderImagesModal
          isVisible={isVisible}
          handleClose={() => setIsVisible(false)}
          orderId={orderId}
        />
      )}
    </>
  );
}

function OrderRiderImagesModal({ orderId, isVisible, handleClose }) {
  return (
    <Modal
      isMaxContent
      isVisible={isVisible}
      type='large'
      title='Rider Images'
      handleClose={handleClose}
      component={<OrderRiderImagesContainer orderId={orderId} />}
    />
  );
}

function OrderRiderImagesContainer({ orderId }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const queryKeys = ['lifeline_apis', 'get_Rider_images', orderId];
  const getRiderImgsEndPoint = `${lifelineEndPoints.GET_RIDER_IMAGES}/${orderId}`;
  const { data, isLoading, isError } = useQueryCall(
    {},
    getRiderImgsEndPoint,
    queryKeys,
  );
  if (isLoading) return <Loader />;

  if (isError || data?.length === 0)
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading={
          isError ? 'something went wrong' : 'Rider has not clicked any image'
        }
      />
    );

  return (
    <OrderRiderImages.Container>
      <OrderRiderImages.RiderImages>
        <PickerImageViewer
          images={data?.map((item) => ({ src: item }))}
          activeIndex={activeIndex}
          updateActiveIndex={setActiveIndex}
        />
      </OrderRiderImages.RiderImages>
      <OrderRiderImages.RiderImageDetails>
        {data?.map((item, index) => (
          <div
            className='RiderImagsList'
            role='button'
            tabIndex={0}
            key={index}
            onClick={() => setActiveIndex(index)}
          ></div>
        ))}
      </OrderRiderImages.RiderImageDetails>
    </OrderRiderImages.Container>
  );
}

OrderRiderImages.Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
`;

OrderRiderImages.RiderImages = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  width: 60%;
`;

OrderRiderImages.RiderImageDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  height: 100%;
  margin-right: 0.5rem;
`;
